import { render, staticRenderFns } from "./procurementContractAction.vue?vue&type=template&id=6f7ede2f&scoped=true"
import script from "./procurementContractAction.vue?vue&type=script&lang=js"
export * from "./procurementContractAction.vue?vue&type=script&lang=js"
import style0 from "./procurementContractAction.vue?vue&type=style&index=0&id=6f7ede2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7ede2f",
  null
  
)

export default component.exports